import React from 'react';
export function Footer() {
  return <footer className="bg-gray-100 py-8 text-center text-gray-600" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-13">
        <p className="mb-6 leading-relaxed" data-id="element-14">To your health and happiness,</p>
        <p className="mb-6 font-bold" data-id="element-15">The Team at KneeRelief</p>
        <p className="mb-6 leading-relaxed italic" data-id="element-16">
          P.S. Remember, you're protected by our 90-day money-back guarantee. If
          this device doesn't give you the same relief it gave Linda, simply
          return it for a full refund. You have absolutely nothing to lose
          except your knee pain.
        </p>
        <div className="border-t border-gray-300 pt-6 mt-6 text-sm" data-id="element-17">
          <p className="mb-2" data-id="element-18">© 2023 KneeRelief. All rights reserved.</p>
          <p data-id="element-19">
            <a href="#" className="text-blue-600 hover:underline" data-id="element-20">
              Privacy Policy
            </a>{' '}
            |
            <a href="#" className="text-blue-600 hover:underline ml-2" data-id="element-21">
              Terms of Service
            </a>
          </p>
        </div>
      </div>
    </footer>;
}